import React, { useEffect, useState } from "react";
import Header from "../../componets/Header";
import { Link, useNavigate } from "react-router-dom";
import { FaCircleArrowLeft } from "react-icons/fa6";
import {
	Badge,
	Card,
	CardBody,
	Col,
	Modal,
	Pagination,
	Row,
	Table,
	Form,
} from "react-bootstrap";
import ApiService from "../../helper/api";
import MainService from "../../helper/mainService";
import { GoCopy } from "react-icons/go";
import ReactSelectOption from "../../componets/ReactSelectOption";

const useDebounce = (value, delay) => {
	const [debouncedValue, setDebouncedValue] = useState(value);
	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
};

const Info = ({ label, children, mono, copy }) => {
	const [copied, setCopied] = useState(false);

	const handleCopy = async () => {
		if (!copy) return;

		try {
			await navigator.clipboard.writeText(children);
			setCopied(true);
			setTimeout(() => setCopied(false), 1500);
		} catch (e) {}
	};

	return (
		<Col md={6}>
			<div
				className={`border rounded p-3 h-100 ${
					copy ? "cursor-pointer hover-shadow" : ""
				}`}
				onClick={() => {
					if (!copy) return false;
					handleCopy();
				}}>
				<div className="d-flex justify-content-between align-items-center mb-1">
					<div className="text-muted small">{label}</div>
					{copy && (
						<span
							role="button"
							title="Copy"
							onClick={handleCopy}
							className="text-secondary"
							style={{ cursor: "pointer" }}>
							<GoCopy size={16} />
						</span>
					)}
				</div>

				{mono ? (
					<code className="text-break">{children}</code>
				) : (
					<div className="fw-semibold">{children}</div>
				)}

				{copied && <div className="text-success small mt-1">✔ Copied</div>}
			</div>
		</Col>
	);
};

const selectOptions = [
	{
		name: "Oll",
		value: null,
	},
	{ name: "Systems", value: true },
	{ name: "Merchants", value: false },
];

function Component(props) {
	const [data, setData] = useState([]);

	const [paginationValues, setPaginationValues] = useState({
		pageNumber: 1,
		pageSize: 10,
		searchParameter: "",
		isSystem: null,
	});

	const [pagination, setPagination] = useState(null);
	const [modalInformation, setModalInformation] = useState({
		open: false,
		item: null,
	});

	const searchDebounce = useDebounce(paginationValues.searchParameter, 1000);

	useEffect(() => {
		if (searchDebounce) {
			const newPaginationValues = {
				...paginationValues,
				startForMore: 0,
			};
			transactionGetAll(newPaginationValues);
		} else if (searchDebounce === "") {
			const newPaginationValues = {
				...paginationValues,
				searchParameter: "",
				startForMore: 0,
			};
			transactionGetAll(newPaginationValues);
		}
	}, [searchDebounce]);

	// useEffect(() => {
	// 	transactionGetAll({ pageNumber: 1, pageSize: 10, searchParameter: "" });
	// }, []);

	const transactionGetAll = paginationValues => {
		MainService.callApi({
			api: ApiService.transactionGetAll,
			data: paginationValues,
			cb: response => {
				if (response?.data?.pagedData?.length) {
					setData(response?.data?.pagedData);
				} else {
					setData([]);
				}
				if (response?.data?.pagination) {
					setPagination(response?.data?.pagination);
				}
				setPaginationValues(paginationValues);
			},
		});
	};

	const handlePageChange = pageNumber => {
		const newPaginationValues = { ...paginationValues };
		newPaginationValues.pageNumber = pageNumber;
		transactionGetAll(newPaginationValues);
	};

	const closeModal = () => {
		setModalInformation({});
	};

	const openModal = item => {
		if (!item) return false;
		setModalInformation({
			open: true,
			item: item,
		});
	};

	const shortLabel = (value, length = 10) => {
		if (!value) return "-";
		return value.length > length ? `${value.slice(0, length)}...` : value;
	};

	const onSelectOptionChange = item => {
		if (!item) {
			return false;
		}
		const newPaginationValues = {
			...paginationValues,
			pageNumber: 1,
			isSystem: item.value,
		};
		transactionGetAll(newPaginationValues);
	};

	return (
		<div>
			<Modal
				show={modalInformation.open}
				size="lg"
				scrollable
				centered
				onHide={() =>
					closeModal({
						open: false,
						item: null,
					})
				}>
				<Modal.Header closeButton>
					<Modal.Title className="d-flex align-items-center gap-2">
						Transaction
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<Row className="g-3">
						<Info label="Network">{modalInformation.item?.chainName}</Info>

						<Info label="Token">
							<Badge bg="success">{modalInformation.item?.tokenSlug}</Badge>
						</Info>

						<Info label="Amount">
							<span className="fw-bold text-primary fs-5">
								{modalInformation.item?.amount}{" "}
								{modalInformation.item?.tokenSlug}
							</span>
						</Info>

						<Info label="Gas Fee">{modalInformation.item?.gasFee}</Info>

						<Info label="Hash" mono copy>
							{modalInformation.item?.hash}
						</Info>

						<Info label="From" mono>
							{modalInformation.item?.from}
							{/* {modalInformation.item?.fromMerchantId ? ( */}
							<div>
								<span className="text-primary">
									Merchant id {modalInformation.item?.fromMerchantId}
								</span>
							</div>
							{/* ) : null} */}
						</Info>

						<Info label="To" mono>
							{modalInformation.item?.to}
							{/* {!!modalInformation.item?.toMerchantId && ( */}
							<div>
								<span className="text-primary">
									Merchant id {modalInformation.item?.toMerchantId}
								</span>
							</div>
							{/* )} */}
						</Info>

						<Info label="Contract" mono>
							{modalInformation.item?.contractAddress}
						</Info>
						<Info label="Date">
							{MainService.convertUTCToLocal(
								modalInformation.item?.createTime,
								"DD-MM-YYYY hh:mm:ss A",
							)}
						</Info>

						{/* <Info label="Hash" mono>
							<a
								href={`https://etherscan.io/tx/${data.hash}`}
								target="_blank"
								rel="noreferrer"
								className="text-decoration-none">
								{data.hash}
							</a>
						</Info> */}
					</Row>
				</Modal.Body>

				<Modal.Footer>
					<button
						className="btn btn-secondary"
						onClick={() => closeModal({ open: false, item: null })}>
						Close
					</button>
				</Modal.Footer>
			</Modal>

			<Header>
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex gap-2 align-items-center">
						<Link to="/">
							<FaCircleArrowLeft size={20} />
						</Link>
						<h4 className="mb-0">Transactions</h4>
					</div>
				</div>
			</Header>
			<Card className="mt-3">
				<CardBody>
					<Row>
						<Col lg={4}>
							<Form.Group className="mb-1" controlId="value">
								<Form.Control
									type="text"
									placeholder="Search"
									required={true}
									value={paginationValues.searchParameter}
									onChange={event => {
										if (event.target.value >= 199) {
											return false;
										}
										setPaginationValues(values => ({
											...values,
											searchParameter: event.target.value,
										}));
									}}
								/>
							</Form.Group>
						</Col>
						<Col lg={4}>
							<ReactSelectOption
								isSearchable={true}
								label={"Տեսակ"}
								value={paginationValues.isSystem}
								items={selectOptions
									.filter(el => el.value !== paginationValues.isSystem)
									.map(el => {
										return { ...el, label: el.name };
									})}
								selectedValue={(() => {
									const selectedItem = {
										...selectOptions.find(
											el => el.value === paginationValues.isSystem,
										),
									};

									if (selectedItem && Object.keys(selectedItem).length) {
										return {
											...selectedItem,
											label: selectedItem.name,
											value: selectedItem.value,
										};
									}
									return null;
								})()}
								onChange={item => {
									onSelectOptionChange(item);
								}}
							/>
						</Col>
					</Row>

					<Table id="table" responsive hover className="mt-2">
						<thead>
							<tr>
								<th>#</th>
								<th>Network</th>
								<th>Hash</th>
								<th className="text-nowrap">From merchant id </th>
								<th>From</th>
								<th className="text-nowrap">To merchant id</th>
								<th>To</th>
								<th>Contract</th>
								<th>Token</th>
								<th>Amount</th>
								<th>Gas Fee</th>
								<th>Date</th>
							</tr>
						</thead>
						<tbody>
							{!!data &&
								!!data.length &&
								data.map((item, index) => (
									<tr
										key={index}
										className="cursor-pointer"
										style={
											item.isSystem
												? { backgroundColor: "rgb(123 204 241)" }
												: {}
										}
										onClick={() => {
											openModal(item);
										}}>
										<td>{index + 1}</td>
										<td>{item.chainName}</td>
										<td>{shortLabel(item.hash)}</td>
										<td>{item.fromMerchantId}</td>
										<td>{shortLabel(item.from)}</td>
										<td>{item.toMerchantId}</td>
										<td>{shortLabel(item.to)}</td>
										<td>{shortLabel(item.contractAddress)}</td>
										<td>{item.tokenSlug}</td>
										<td>{item.amount}</td>
										<td>{item.gasFee}</td>

										{/* <td className=" " style={{ width: 100 }}>
											<span className="max-line-1">{item.message}</span>
										</td>
										<td>
											<span
												className={`badge ${
													item.isReed ? "bg-secondary" : "bg-danger new-badge"
												}`}
												style={{ fontSize: "0.9rem", padding: "0.5em 0.8em" }}>
												{item.isReed ? "Read" : "New"}
											</span>
										</td> */}
										<td className="text-nowrap">
											{MainService.convertUTCToLocal(
												item.createTime,
												"DD-MM-YYYY hh:mm:ss A",
											)}
										</td>
										{/* <td>{item.createDate}</td> */}
									</tr>
								))}
						</tbody>
					</Table>

					<Pagination className="mt-3 mb-1 justify-content-end coustem_pagination align-self-stretch">
						<Pagination.First
							onClick={() => handlePageChange(1)}
							disabled={paginationValues.pageNumber === 1}
						/>
						<Pagination.Prev
							onClick={() => handlePageChange(paginationValues.pageNumber - 1)}
							disabled={paginationValues.pageNumber === 1}
						/>
						<Pagination.Item className="coustem_pagination_item" active>
							{paginationValues.pageNumber}
						</Pagination.Item>

						<Pagination.Next
							onClick={() => handlePageChange(paginationValues.pageNumber + 1)}
							disabled={pagination?.totalPages === paginationValues.pageNumber}
						/>
					</Pagination>
				</CardBody>
			</Card>
		</div>
	);
}

const loader = async () => {
	return [];
};

const Transaction = Object.assign(Component, { loader });

export default Transaction;
